export function appointmentValidate(appointment){
    var result = true;

    result = validateId(appointment.id);
    // result = validateEta(appointment.eta);
    result = validateArrivalDate(appointment.arrival_date);
    // result = validateModulationDate(appointment.modulation_date);
    // result = validateModulationTime(appointment.modulation_time);
    // result = validateOriginSupplier(appointment.origin_supplier);
    // result = validateStandbyProducts(appointment.standby_products);
    // result = validateSealNumber(appointment.seal_number);
    // result = validateBillOfLading(appointment.bill_of_lading);
    // result = validateCarrierLine(appointment.carrier_line);
    // result = validateLicensePlate(appointment.license_plate);
    result = validateContainerNumber(appointment.container_number);
    // result = validateTractor(appointment.tractor);
    // result = validatePackingList(appointment.packing_list);
    // result = validateManeuvers(appointment.maneuvers);
    // result = validateAdditionalServices(appointment.additional_services);
    // result = validateCargoType(appointment.cargo_type);
    // result = validateCommentary(appointment.commentary);
    // result = validateDescription(appointment.description);
    // result = validateStatus(appointment.status);
    // result = validatePatentNumber(appointment.patent_number);
    // result = validateCustomsNumber(appointment.customs_number);
    // result = validateCustomsDocType(appointment.customs_doc_type);
    // result = validateNotices(appointment.notices);
    // result = validateActive(appointment.active);
    // result = validateConsignmentNote(appointment.consignment_note);
    // result = validateIsRfid(appointment.is_rfid);
    // result = validateTransportType(appointment.transport_type);
    // result = validateIsNational(appointment.is_national);
    // result = validateModulationStatus(appointment.modulation_status);
    // result = validateEmails(appointment.emails);
    // result = validatePurchaseOrder(appointment.purchase_order);
    // result = validateDriversName(appointment.drivers_name);
    // result = validatePetition(appointment.petition);
    // result = validateEntryPetition(appointment.entry_petition);
    // result = validateRemittance(appointment.remittance);
    // result = validateMerchandiseGoodConditions(appointment.merchandise_good_conditions);
    // result = validatePackagingCompliesConditions(appointment.packaging_complies_conditions);
    // result = validateSealGoodConditions(appointment.seal_good_conditions);
    // result = validatePackingType(appointment.packing_type);
    // result = validateUnitGoodConditions(appointment.unit_good_conditions);
    // result = validateUnitDamageSpecifications(appointment.unit_damage_specifications);
    // result = validateDocumentBlobs(appointment.document_blobs);
    // result = validateUnknownProducts(appointment.unknown_products);
    // result = validateShowAduana(appointment.show_aduana);
    // result = validateOutcomeAppointment(appointment.outcome_appointment);
    // result = validateAlreadyPicked(appointment.already_picked);
    // result = validateFilesStatus(appointment.files_status);
    // result = validateDeletedAt(appointment.deleted_at);
    // result = validateWarehouse(appointment.warehouse);
    // result = validateGate(appointment.gate);
    // result = validateOrder(appointment.order);
    // result = validateAppointmentStatus(appointment.appointment_status);
    result = validateClient(appointment.client);
    result = validateOperation(appointment.operation);
    // result = validateDetailOrders(appointment.detail_orders);
    // result = validateUser(appointment.user);
    // result = validateDocumentManagement(appointment.document_management);
    
    return result;
}

function validateId(id) {
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateClient(client) {
    return (typeof client === 'object' && typeof client.name === 'string');
}

function validateContainerNumber(container_number) {
    return (typeof container_number === 'string');
}

function validateArrivalDate(arrival_date) {
    return (typeof arrival_date === 'string')
}

function validateOperation(operation) {
    return (typeof operation === 'object' && typeof operation.description === 'string' && typeof operation.description1 === 'string')
}